<template>
  <div class="table-wrap">
    <table>
      <thead><tr><th v-for="col in columns" :key="col.key">{{ col.label }}</th></tr></thead>
      <tbody>
        <tr v-for="(row, idx) in rows" :key="rowKey ? String(row[rowKey]) : idx">
          <td v-for="col in columns" :key="col.key">
            <slot :name="col.key" :row="row">{{ row[col.key] ?? "-" }}</slot>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="!rows.length" class="empty">暂无数据</div>
  </div>
</template>

<script setup lang="ts" generic="T extends Record<string, any>">
defineProps<{ columns: { key: string; label: string }[]; rows: T[]; rowKey?: string }>();
</script>
